import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDScRestart, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import store from '../../../store/store';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { getHostByGameId, hostsSliceActions } from '../../../modules/host/slice';
import { GameState } from '../../games/enums/GameState';

export class CMDScRestartHandler extends AbstractHandler {
    _command: CMDScRestart;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScRestart;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const gameId = this._command.GameID;
        const state = store.getState();
        const host = getHostByGameId(state, gameId);

        if (host) {
            switch (host.GameType) {
                case GameTypeEnum.SeDie:
                case GameTypeEnum.SicBo:
                case GameTypeEnum.Roulette:
                    dispatch(
                        hostsSliceActions.updateGameState({
                            hostId: host.HostId,
                            state: GameState.ReStart,
                        })
                    );
                    dispatch(
                        hostsSliceActions.updateIsRestart({
                            hostId: host.HostId,
                            isRestart: true
                        })
                    );
                    // dispatch(
                    //     popupSliceActions.open(
                    //         'sedie.reshake',
                    //         undefined,
                    //         POPUP_TYPE.POPUP,
                    //         2000
                    //     )
                    // );
                    //     break;
                    // case GameTypeEnum.Roulette:
                    // dispatch(
                    //     popupSliceActions.open(
                    //         'roulette.respin',
                    //         undefined,
                    //         POPUP_TYPE.POPUP,
                    //         2000
                    //     )
                    // );
                    break;
            }
        }
    }
}
